// [ref] https://stackoverflow.com/questions/44134212/best-way-to-flatten-js-object-keys-and-values-to-a-single-depth-array
export const objectFlattener = (
  obj: { [key: string]: any },
  excludeKeys: string[] = [],
  parent = '',
  res: { [key: string]: any } = {}
) => {
  for (let key in obj) {
    let propName = parent ? `${parent}[${key}]` : key
    if (typeof obj[key] == 'object') {
      objectFlattener(obj[key], excludeKeys, propName, res)
    } else if (!excludeKeys.includes(key)) {
      res[propName] = obj[key]
    }
  }
  return res
}
